import { Box, Typography } from '@material-ui/core'
import { FrontendEvent } from 'common/types'
import { FunctionComponent } from 'react'
import { SummitDate } from '../SummitDate'
interface SummitTicketConfirmationDetails {
  theme: any
  event: FrontendEvent
  isDevice: Boolean
}

export const SummitTicketConfirmationDetails: FunctionComponent<SummitTicketConfirmationDetails> = ({
  event,
  isDevice
}) => {
  return (
    <>
      <Box width="100%" m="1em 0">
        <Box textAlign={isDevice ? 'center' : 'left'}>
          <Typography>
            <Box fontSize="2em" fontWeight="bold" marginBottom="0.5em">
              {event?.title}
            </Box>
          </Typography>
        </Box>
        <SummitDate event={event} isDevice={isDevice} />
      </Box>
      <Typography>
        <Box
          fontWeight="bold"
          fontSize="2em"
          marginBottom="0.5em"
          textAlign={isDevice ? 'center' : 'left'}
        >
          Success! You're going to {event?.title}
        </Box>
      </Typography>
      <Typography variant="body1" align="justify">
        <Box>
          Get ready to connect with 20,000+ tech and business professionals, learn from industry leaders, expand your
          network and level up in your career.
        </Box>
        <Box padding="1em 0">
          You will receive an email with confirmation details shortly. If you don't see an email, check your spam/junk
          folder.
        </Box>
      </Typography>
    </>
  )
}
